export default __webpack_public_path__ + "static/media/twitter.396b28d1.svg";